import { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Modal,Form } from "react-bootstrap";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import DOMPurify from "dompurify";

const UpdateAgent = ({show,hide,agentStatus}) => {
  const [status, setStatus] = useState();
  const [agentStatuses, setAgentStatuses] = useState();
  const [checked, setChecked] = useState({
    changeStatus: true,
    changePin: false,
  });
  const [confirmPin, setConfirmPin] = useState("")
  const [isError, setIsError] = useState(false)
  const [dataToSend, setDataToSend] = useState({})
  const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const queryClient = useQueryClient();
  useEffect(() => {
    fetchAgentStatuses();
  }, []);
    useEffect(() => {
        setStatus(agentStatus);
    }, [agentStatus]);
  // fetch agents statuses
  const fetchAgentStatuses = () => {
    const url = `${baseUrl}/agents/statuses`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setAgentStatuses(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Update an agent
  const updateAgentStatus = (e) => {
    e.preventDefault();
    const url = `${baseUrl}/agents`;
    fetch(url, {
      method: "PUT",
      headers: new Headers({
        Authorization: "Bearer " + user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(status),
    })
      .then((res) => {
        if (res.ok) {
          queryClient.invalidateQueries(["fetch-agents"])
          hide();
          toastSuccess("Agent status changed");
        } else {
          toastError("Could not update Agent");
        }
        return res.json();
      })
      .then((res) => {
        queryClient.invalidateQueries(["fetch-agents"]);
        // setAgentId(res?.id);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Change agent Pin
  const changeAgentPin  = (e) => {
    e.preventDefault();
    if (dataToSend.newPassword !== confirmPin) {
      setIsError(true)
    } else {
      const url = `${baseUrl}/users/changepassword`;
      fetch(url, {
        method: "POST",
        headers: new Headers({
          Authorization: "Bearer " + user.access_token,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(dataToSend),
      })
        .then((res) => {
          if (res.ok) {
            queryClient.invalidateQueries(["fetch-agents"]);
            hide();
            toastSuccess("Agent pin changed");
          } else {
            toastError("Could not reset Agent pin");
          }
          return res.json();
        })
        .then((res) => {
          // setAgentId(res?.id);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setDataToSend({
      ...dataToSend,
      [name]: DOMPurify.sanitize(value),
    })
  }
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <Modal.Title>Edit Agent</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <div className='d-flex justify-content-center mb-4'>
            <Form.Check
              type='radio'
              id='status'
              label='Change status'
              name='update'
              checked={checked.changeStatus}
              onChange={() =>
                setChecked({
                  changeStatus: true,
                })
              }
            />
            <div>
              <Form.Check
                type='radio'
                label='Change Pin'
                id='pin'
                className='ml-2'
                name='update'
                checked={checked.changePin}
                onChange={() =>
                  setChecked({
                    changePin: true,
                  })
                }
              />
            </div>
          </div>
          <Form
            onSubmit={checked.changeStatus ? updateAgentStatus : changeAgentPin}
          >
            {checked.changeStatus && (
              <>
                <label className='ml-2'>Status</label>
                <select
                  className='form-control input-select'
                  onChange={(e) => {
                    const { value, options } = e.target;
                    const label = options[options.selectedIndex].label;
                    setStatus({
                      ...status,
                      status: {
                        id: value,
                        name: label,
                      },
                    });
                  }}
                >
                  <option value={status?.status.id}>
                    {status?.status.name}
                  </option>
                  {agentStatuses?.map((status) => (
                    <option value={status.id} key={status.id}>
                      {status.name}
                    </option>
                  ))}
                </select>
              </>
            )}
            {checked.changePin && (
              <div>
                <label className='ml-2'>Username</label>
                <input
                  placeholder='Enter agent username'
                  type='text'
                  className='form-control input-select mb-2'
                  name='username'
                  onChange={handleOnChange}
                  required
                />
                <label className='ml-2'>Pin</label>
                <div style={{ position: "relative" }}>
                  <input
                    placeholder='Enter pin'
                    type={showPin ? "text" : "password"}
                    className='form-control input-select mb-2'
                    name='newPassword'
                    onChange={handleOnChange}
                    onKeyUp={() => setIsError(false)}
                    required
                  />
                  {dataToSend?.newPassword?.length > 0 && (
                    <i
                      className='fa fa-eye'
                      aria-hidden='true'
                      style={{
                        position: "absolute",
                        right: 15,
                        bottom: 8,
                        cursor: "pointer",
                        fontSize: 20,
                        color: "#0000ff",
                      }}
                      onClick={() => setShowPin(!showPin)}
                    />
                  )}
                </div>
                <label className='ml-2'>Confirm Pin</label>
                <div style={{ position: "relative" }}>
                  <input
                    placeholder='Confirm Pin'
                    type={showConfirmPin ? "text" : "password"}
                    className='form-control input-select mb-2'
                    onChange={(e) => setConfirmPin(e.target.value)}
                    onKeyUp={() => setIsError(false)}
                    required
                  />
                  {confirmPin.length > 0 && (
                    <i
                      className='fa fa-eye'
                      aria-hidden='true'
                      style={{
                        position: "absolute",
                        right: 15,
                        bottom: 8,
                        cursor: "pointer",
                        fontSize: 20,
                        color: "#0000ff",
                      }}
                      onClick={() => setShowConfirmPin(!showConfirmPin)}
                    />
                  )}
                </div>
                {isError && <span style={{ color: "red" }}>Pin not Match</span>}
              </div>
            )}
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateAgent;
